<template>
  <article class="col-md-18">
    <h1>Top ups <span v-if="showAll">(all)</span></h1>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">iccid</th>
          <th scope="col">ip</th>
          <th scope="col">Rateplan</th>
          <th scope="col">Jasper wireless code</th>
          <th scope="col" v-if="showAll">Reseller</th>
          <th scope="col">Date</th>
          <th scope="col">Success</th>
        </tr>
        <tr>
          <th><a href="/rest/topup/export">Export as Excel</a></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="topup in topups" :key="topup.id">
          <td>{{ topup.iccid }}</td>
          <td>{{ topup.ip }}</td>
          <td>{{ topup.rateplanDisplayName }}</td>
          <td>{{ topup.rateplanJasperwirelessCode }}</td>
          <td v-if="showAll">{{ topup.reseller }}</td>
          <td>{{ topup.topupMoment.split('T')[0] }}</td>
          <td>{{ topup.success }}</td>
        </tr>
      </tbody>
    </table>
    <button
      type="button"
      class="btn btn-sm btn-primary mr-2"
      @click="prevPage()"
    >
      Prev
    </button>
    <button
      type="button"
      class="btn btn-sm btn-primary mr-2"
      @click="nextPage()"
    >
      Next
    </button>
    page: {{ currPage }} of {{ numberOfPages }}
  </article>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'TopUps',
  data() {
    return {
      loading: false,
      topups: null,
      page: 0,
      pageSize: 25,
      numberOfResults: null,
    }
  },
  computed: {
    ...mapGetters('auth', ['resellerDisplayName']),
    currPage() {
      return this.page + 1
    },
    numberOfPages() {
      return Math.ceil(this.numberOfResults / this.pageSize)
    },
    showAll() {
      return !!this.$route.meta.allResellers
    },
  },
  methods: {
    getTopUps() {
      const params = {
        page: this.page,
        pageSize: this.pageSize,
      }

      if (!this.showAll) {
        params.reseller = this.resellerDisplayName
      }

      this.loading = true
      axios
        .get('/rest/topup', { params })
        .then(response => {
          this.topups = response.data.results
          this.numberOfResults = response.data.numberOfResults
        })
        .finally(() => {
          this.loading = false
        })
    },
    nextPage() {
      this.page++
      this.getTopUps()
    },
    prevPage() {
      this.page--
      this.getTopUps()
    },
  },
  watch: {
    showAll() {
      this.page = 0
      this.getTopUps()
    },
  },
  beforeMount() {
    this.getTopUps()
  },
}
</script>

<style lang="scss"></style>
